import RootRoutes from './routes';
import React, { useEffect, useState } from 'react';
import './App.css';
import './index.css';
import './assets/font/font.css';
import './assets/css/common.css';
import './assets/css/accessibility.css';
import './assets/css/ag-theme-material.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';

import SplashScreen from './components/splashscreen/SplashScreen';
import { LoadingProvider, useLoading } from './constants/LoadingContext';
import { setLoadingHandler } from './assets/js/comm';
import LoadingModal from './components/comm/LoadingModal';
import './utils/pdfWorker';
import { useLocation } from 'react-router-dom';
import { useNetworkStatus } from './hook/useNetworkStatus';
import NetworkErrorBox from './components/error/NetworkError';
import GtmPageTracker from './routes/GtmPageTracker';

function App() {
    const { setLoading } = useLoading();
    const location = useLocation();
    const isOnline = useNetworkStatus();

    const isTargetPage = [
        '/HomeCareMain',
        '/calender',
        '/PillAlarm',
        '/HealthAlarm',
        '/PillDetail',
        '/PillDetailUser',
        '/StepsMain',
        '/hospitalCare',
        '/StepsDashboard',
        '/StepsRecordList',
        '/BodyMassRecord',
        '/BodyMassWrite',
        '/BloodPressureRecord',
        '/BloodPressureWrite',
        '/BloodSugarRecord',
        '/BloodSugarWrite',
        '/AppAlarmSetting',
        '/ServiceNotice',
        '/ServiceFaqLists',
        '/ServiceUseGuide',
        '/ServicePolicy',
        '/BusinessInform',
        '/AppSettings',
        '/Alarm',
        '/TotalMenu',
        '/hospitalCare/MedicalReservationDetailsIn',
        '/hospitalCare/InspectionDetail',
        '/hospitalCare/PrescriptionDetail',
        '/hospitalCare/MedicalDetails',
        '/hospitalCare/InspectionHistory',
        '/hospitalCare/PrescriptionHistory',
        '/hospitalCare/MedicalHistory',
        '/hospitalCare/HospitalInformation',
        '/hospitalCare/DepartmentInform',
        '/hospitalCare/DepartmentDetail',
        '/hospitalCare/DoctorDetail',
        '/hospitalCare/LocationInfo',
        '/hospitalCare/NoticeLists',
        '/hospitalCare/PhoneNumInfo',
        '/hospitalCare/ParentalSettings',
        '/hospitalCare/ParentalRegister',
        '/hospitalCare/Amenity',
        '/hospitalCare/Directions',
        '/hospitalCare/Parking',
        '/hospitalCare/FAQLists',
        '/RecordSetting',
        '/RecordSettingDetail',
        '/HospitalOrderSetting',
        '/MyHospitalDisconnect',
        '/MyHospitalConnection',
        '/MyHospitalSetting',
        '/CustomDiseaseSetting',
        '/Accessibility',
        '/ErrorReport',
        '/MyInfoWrite',
        '/AppVersion',
        '/ContactlessMain',
        '/'

    ].includes(location.pathname);

    //결제창 스플레시 제외
    const isNonSplashPage = ["/pay/register","/pay/result"].includes(location.pathname);

    const [splashComplete, setSplashComplete] = useState(() => {
        if (typeof window === 'undefined') return false;
        return !!sessionStorage.getItem('splashShown');
    });

    useEffect(() => {
        const savedContrast = localStorage.getItem("hiContrast");
        const savedFont = localStorage.getItem("fontSize");

        if (savedContrast === "true") {
            document.documentElement.classList.add("high-contrast");
        } else {
            document.documentElement.classList.remove("high-contrast");
        }

        document.documentElement.classList.remove("font-basic", "font-medium", "font-large");
        if (savedFont) {
            document.documentElement.classList.add(`font-${savedFont}`);
        } else {
            document.documentElement.classList.add("font-basic");
        }
    }, []);

    useEffect(() => {
        setLoadingHandler(setLoading);
    }, [setLoading]);

    return (
        <React.StrictMode>
            {!isOnline && <NetworkErrorBox />}

            {!isTargetPage && <LoadingModal />}

            {/* 결제창 스플레시 제외 */}
            {!splashComplete && !isNonSplashPage && (
                <SplashScreen onComplete={() => setSplashComplete(true)} />
            )}

            {/* GTM 페이지뷰 추적 - BrowserRouter 바로 아래 */}
            <GtmPageTracker />

            {/* 결제창 스플레시 제외 */}
            {(splashComplete || isNonSplashPage) && <RootRoutes />}
        </React.StrictMode>
    );
}

export default function Root() {
    return (
        <LoadingProvider>
            <App />
        </LoadingProvider>
    );
}
